import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'global_duplicated_click_modal_alert',
    defaultMessage: 'You recently viewed this ad',
  },
  relatedTitle: {
    id: 'global_similar_ads',
    defaultMessage: 'Similar properties',
  },
  subtitle: {
    id: 'global_duplicated_click_modal_question',
    defaultMessage: 'Are you sure you want to view it again?',
  },
  buttonText: {
    id: 'global_duplicated_click_modal_yes',
    defaultMessage: "Yes, I'd like to see it again",
  },
  linkText: {
    id: 'global_web_popup_suggest_recommendation_msg_close_popup',
    defaultMessage: "No thanks! I'd like to continue browsing Trovit...",
  },
});



// WEBPACK FOOTER //
// ./app/Serp/components/Modals/RelatedAdsModals/relatedAdsModalMessages.js